import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IDepartment } from './department';
import { IDepartmentFormValues } from './departmentFormValues';
import { IDepartmentUpsert } from './departmentUpsert';

export default class DepartmentModelHelper {
    public static createFormValues = (department : IDepartment | null) : IDepartmentFormValues => {
        if (!department) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            description: '',
            shortDescription: '',
            isActive: true,
        };

        return {
            id: department.id,
            guid: department.guid,
            code: department.code,
            description: department.description,
            shortDescription: department.shortDescription,
            isActive: department.isActive,
        };
    };

    public static createUpsert = (formValues : IDepartmentFormValues) : IDepartmentUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            description: formValues.description,
            shortDescription: formValues.shortDescription,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IDepartmentFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        description: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        shortDescription: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
